import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html'
})
export class ContactUsComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-left iq-title-box-2',
    title: 'Get In Touch',
    subTitle: 'Contact With US  ',
    titleIcon: '',
    description: 'State the name of your server and issue only. We will get back to you'
  };
  constructor() { }

  ngOnInit(): void {
  }

}
